export default "__VITE_ASSET__Dx0sRLPE__"